import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  mainLabel: {
    marginTop: theme.spacing(10)
  },
  boldedLetters: {
    fontWeight: 'bold'
  },
  notificationCard: {
    marginTop: theme.spacing(8)
  },
  formContainer: {
    marginTop: theme.spacing(5)
  },
  buttonContainer: {
    display: 'flex'
  },
  internalNotes: {
    marginRight: theme.spacing(2)
  },
  buttons: {
    marginTop: theme.spacing(4),
    marginLeft: theme.spacing(4),
    paddingRight: 25,
    paddingLeft: 25
  },
  loadingContainer: {
    marginTop: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  loadingIcon: {
    marginBottom: theme.spacing(4)
  }
});

export default makeStyles(styles);
